









const siteUrl = process.env.VUE_APP_SITE_URL;

export default {
  setup() {
    return {
      siteUrl
    };
  }
};
